import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, CustomLoginGuard, I18nConfig, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { FormErrorsModule, MediaModule, PageSlotModule } from '@spartacus/storefront';
import { userAccountTranslationChunksConfig, userAccountTranslationsEn } from '@spartacus/user/account/assets';
import { LoginFormComponentService } from '@spartacus/user/account/components';
import { KnBrLoginFormComponent } from './kn-br-login-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        MediaModule,
        PageSlotModule,
        FormErrorsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtLoginFormComponent: {
                    component: KnBrLoginFormComponent,
                    // guards: [CustomLoginGuard] // uncomment this only for spartacus login
                },
            },
        } as CmsConfig),
        KnBrLoginFormComponent,
    ],
    exports: [KnBrLoginFormComponent],
    providers: [
        LoginFormComponentService,
        provideConfig({
            i18n: {
                resources: userAccountTranslationsEn,
                chunks: userAccountTranslationChunksConfig,
            },
        } as I18nConfig),
    ]
})
export class KnBrLoginFormModule {}
